/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CarePrincipalDTO,
    CarePrincipalDTOFromJSON,
    CarePrincipalDTOToJSON,
    SignInformationDTO,
    SignInformationDTOFromJSON,
    SignInformationDTOToJSON,
    SignatureInstanceResponse,
    SignatureInstanceResponseFromJSON,
    SignatureInstanceResponseToJSON,
} from '../models';

export interface CreateContractRequest {
    isSigned: boolean;
    signInformationDTO: SignInformationDTO;
}

export interface GetCarePrincipalsEligibleForContractRequest {
    careProviderId: string;
}

export interface GetContractRequest {
    contractId: string;
}

export interface GetSignedContractRequest {
    carePrincipalId: string;
    careProviderId: string;
}

export interface SignContractRequest {
    carePrincipalId: string;
    careProviderId: string;
    contractId: string;
}

/**
 * 
 */
export class ContractApi extends runtime.BaseAPI {

    /**
     */
    async approveContractRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/comfact/approve/contract`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async approveContract(initOverrides?: RequestInit): Promise<void> {
        await this.approveContractRaw(initOverrides);
    }

    /**
     */
    async createContractRaw(requestParameters: CreateContractRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.isSigned === null || requestParameters.isSigned === undefined) {
            throw new runtime.RequiredError('isSigned','Required parameter requestParameters.isSigned was null or undefined when calling createContract.');
        }

        if (requestParameters.signInformationDTO === null || requestParameters.signInformationDTO === undefined) {
            throw new runtime.RequiredError('signInformationDTO','Required parameter requestParameters.signInformationDTO was null or undefined when calling createContract.');
        }

        const queryParameters: any = {};

        if (requestParameters.isSigned !== undefined) {
            queryParameters['isSigned'] = requestParameters.isSigned;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/comfact/contract`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignInformationDTOToJSON(requestParameters.signInformationDTO),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async createContract(isSigned: boolean, signInformationDTO: SignInformationDTO, initOverrides?: RequestInit): Promise<string> {
        const response = await this.createContractRaw({ isSigned: isSigned, signInformationDTO: signInformationDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalsEligibleForContractRaw(requestParameters: GetCarePrincipalsEligibleForContractRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CarePrincipalDTO>>> {
        if (requestParameters.careProviderId === null || requestParameters.careProviderId === undefined) {
            throw new runtime.RequiredError('careProviderId','Required parameter requestParameters.careProviderId was null or undefined when calling getCarePrincipalsEligibleForContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/comfact/careprovider/{careProviderId}/contract-eligible/careprincipals`.replace(`{${"careProviderId"}}`, encodeURIComponent(String(requestParameters.careProviderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CarePrincipalDTOFromJSON));
    }

    /**
     */
    async getCarePrincipalsEligibleForContract(careProviderId: string, initOverrides?: RequestInit): Promise<Array<CarePrincipalDTO>> {
        const response = await this.getCarePrincipalsEligibleForContractRaw({ careProviderId: careProviderId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContractRaw(requestParameters: GetContractRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling getContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/comfact/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getContract(contractId: string, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.getContractRaw({ contractId: contractId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSignedContractRaw(requestParameters: GetSignedContractRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getSignedContract.');
        }

        if (requestParameters.careProviderId === null || requestParameters.careProviderId === undefined) {
            throw new runtime.RequiredError('careProviderId','Required parameter requestParameters.careProviderId was null or undefined when calling getSignedContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/comfact/careprincipal/{carePrincipalId}/careprovider/{careProviderId}/signed/contract`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"careProviderId"}}`, encodeURIComponent(String(requestParameters.careProviderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getSignedContract(carePrincipalId: string, careProviderId: string, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.getSignedContractRaw({ carePrincipalId: carePrincipalId, careProviderId: careProviderId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async signContractRaw(requestParameters: SignContractRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SignatureInstanceResponse>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling signContract.');
        }

        if (requestParameters.careProviderId === null || requestParameters.careProviderId === undefined) {
            throw new runtime.RequiredError('careProviderId','Required parameter requestParameters.careProviderId was null or undefined when calling signContract.');
        }

        if (requestParameters.contractId === null || requestParameters.contractId === undefined) {
            throw new runtime.RequiredError('contractId','Required parameter requestParameters.contractId was null or undefined when calling signContract.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/comfact/careprincipal/{carePrincipalId}/careprovider/{careProviderId}/contract/{contractId}/signing`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"careProviderId"}}`, encodeURIComponent(String(requestParameters.careProviderId))).replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignatureInstanceResponseFromJSON(jsonValue));
    }

    /**
     */
    async signContract(carePrincipalId: string, careProviderId: string, contractId: string, initOverrides?: RequestInit): Promise<SignatureInstanceResponse> {
        const response = await this.signContractRaw({ carePrincipalId: carePrincipalId, careProviderId: careProviderId, contractId: contractId }, initOverrides);
        return await response.value();
    }

}
